import SvgIcon from "@mui/material/SvgIcon";
import { ReactComponent as BatotoIcon } from "./bato-icon.svg";

const Batoto = (props: any) => {
  return (
    <SvgIcon component={ BatotoIcon } {...props} />
  );
}

export default Batoto;